/* ============================================================
   PTS - FAQ (PTS-7698)
   ------------------------------------------------------------
   One job: hold a row open long enough to animate shut.

   Opening needs no help. Closing does, because a closed <details>
   does not render its contents at all, so the answer is gone
   before the slide can run. The CSS asks the browser to hold it
   with a discrete transition on content-visibility, which Chrome
   honours and Safari does not, and there is nothing further CSS
   can do about that.

   So the click is caught while the row is open, the row is sent
   to its closed size with the open attribute still in place, and
   the attribute is dropped once the slide has finished.

   Delegated from the document, so rows re-rendered by the theme
   editor are picked up without rebinding.
   ============================================================ */

(() => {
  // a page can hold more than one FAQ section, and each would load this file
  if (window.__ptsFaqClose) return;
  window.__ptsFaqClose = true;

  // without ::details-content there is no slide to wait for: leave the
  // browser's own instant open and close alone
  if (!window.CSS || !CSS.supports('selector(::details-content)')) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new WeakMap();

  function slideDuration(item) {
    const declared = getComputedStyle(item).getPropertyValue('--fq-panel-duration').trim();
    const value = parseFloat(declared);
    if (!value) return 0;
    return declared.endsWith('ms') ? value : value * 1000;
  }

  function finish(item) {
    clearTimeout(timers.get(item));
    timers.delete(item);
    item.removeAttribute('data-closing');
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest && event.target.closest('.pts-faq__question');
    if (!summary) return;

    const item = summary.closest('.pts-faq__item');
    if (!item || !item.open) return;

    // clicking again mid-slide sends the row back open
    if (item.hasAttribute('data-closing')) {
      event.preventDefault();
      finish(item);
      return;
    }

    const duration = reduced.matches ? 0 : slideDuration(item);
    if (!duration) return;

    event.preventDefault();
    item.setAttribute('data-closing', '');
    timers.set(item, setTimeout(() => {
      finish(item);
      item.open = false;
    }, duration));
  });
})();
